export const baseURL = "https://flirtzy.tech/";
//export const baseURL = "http://localhost:5001/";
export const secretKey = "ReQwQIVvKq";
export const projectName = "Flirtzy";
